import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { StrapiService } from '../../services/strapi.service';
import { SeoService } from '../../services/seo.service';
import { SectionsComponent } from '../sections/sections.component';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { SponsorBannerComponent } from '../sponsor-banner/sponsor-banner.component';

@Component({
  selector: 'app-page',
  standalone: true,
  imports: [
    CommonModule,
    SectionsComponent,
    SponsorBannerComponent
  ],
  templateUrl: './page.component.html',
  styleUrl: './page.component.less'
})
export class PageComponent {
  private activatedRoute = inject(ActivatedRoute);
  private strapiService = inject(StrapiService);
  private seoService = inject(SeoService);
  public page: any;

  public sponsors$!: Observable<any>;
  private readonly store = inject(Store);

  ngOnInit(): void {

    this.activatedRoute.paramMap.subscribe(params => {
      const page = params.get('page');

      this.strapiService.getPage(page!).subscribe({
        next: (page) => {
          this.page = page;

          console.log('Fetched page data:', page);

          if (page?.seo) {
            this.seoService.updateSeo(page.seo);
          }
        }
      });
    });

    this.sponsors$ = this.store.select((state) => {
      return state.globalData?.sponsors;
    });
  }
}
